const LeadsplusReport = () =>
  import(/* webpackChunkName: 'LeadsplusReport' */ '@/Leadsplus/components/LeadsplusReport');
const BonusLeads = () =>
  import(/* webpackChunkName: 'BonusLeadsplus' */ '@/Leadsplus/components/BonusLeads');
const AccountManagement = () =>
  import(/* webpackChunkName: 'AccountManagement' */ '@/Leadsplus/components/AccountManagement');
export default [
  {
    path: '/leadsplusreporting',
    name: 'leadsplusreporting',
    component: LeadsplusReport,
    meta: { auth: true },
  },
  {
    path: '/bonusleads',
    name: 'leadsplusreporting.bonusleads',
    component: BonusLeads,
    meta: { auth: true },
  },
  {
    path: '/accountmanagement',
    name: 'leadsplusreporting.accountmanagement',
    component: AccountManagement,
    meta: { auth: true },
  },
];
